<oaj-header-itx (home)="Inicio()"></oaj-header-itx>
<div class="main-container">
    <aside class="sidebar">
        <div class="sidebar-section">
            <h3>Notificaciones:</h3>
            <div class="notification-item" [ngClass]="{'active': ID === 2}" (click)="SelectItx(2)"
                (keydown.enter)="SelectItx(2)" (keydown.space)="SelectItx(2)" tabindex="0">
                <i class="fas fa-bell-slash icon"></i>
                <span>Pendientes</span>
                <span class="count">{{ totalesNotificaciones.noNotificadas }}</span>
            </div>
            <div class="notification-item " [ngClass]="{'active': ID === 1}" (click)="SelectItx(1)"
                (keydown.enter)="SelectItx(1)" (keydown.space)="SelectItx(1)" tabindex="1">
                <i class="fas fa-bell icon"></i>
                <span>Notificadas</span>
                <!--  <span class="count">{{ totalesNotificaciones.notificadas }}</span> -->
            </div>

            <div class="total-notifications">
                <!--  <span>Total: {{ totalNotificaciones }}</span> -->
            </div>
        </div>
        <div class="sidebar-section">
            <h3>Consulta expediente electrónico:</h3>
            <div class="notification-item" [ngClass]="{'active': ID === 5}" (click)="SelectItx(5)"
                (keydown.enter)="SelectItx(5)" (keydown.space)="SelectItx(5)" tabindex="2">
                <i class="fas fa-book-open icon"></i>
                <span>Expediente electrónico</span>
            </div>

            <div class="total-notifications"></div>
        </div>
        @if(!bOrganoSupervisado)
            {
        <div class="sidebar-section">
            <h3>Envío demandas y promociones:</h3>
            
            <div class="notification-item" [ngClass]="{'active': ID === 4}" (click)="SelectItx(4)"
                (keydown.enter)="SelectItx(4)" (keydown.space)="SelectItx(4)" tabindex="3">
                <i class="fas fa-sort-amount-up-alt icon"></i>
                <span>Promoción electrónica</span>
            </div>
            <div class="notification-item" [ngClass]="{'active': ID === 3}" (click)="SelectItx(3)"
                (keydown.enter)="SelectItx(3)" (keydown.space)="SelectItx(3)" tabindex="4">
                <i class="fas fa-balance-scale icon"></i>
                <span>Demanda electrónica</span>
            </div>
            

            <div class="notification-item" [ngClass]="{'active': ID === 12}" (click)="SelectItx(12)"
                (keydown.enter)="SelectItx(12)" (keydown.space)="SelectItx(12)" tabindex="5">
                <i class="fas fa-search icon"></i>
                <span>Consulta folio de envío de demanda</span>
            </div>

            <div class="notification-item" [ngClass]="{'active': ID === 7}" (click)="SelectItx(7)"
                (keydown.enter)="SelectItx(7)" (keydown.space)="SelectItx(7)" tabindex="6">
                <i class="fas fa-print icon"></i>
                <span>Reimpresión de acuses</span>
            </div>
            <div class="total-notifications"></div>
        </div>
    }
        @if(!bOrganoSupervisado)
        {
        <div class="sidebar-section">
            <h3>Reporte fallas técnicas:</h3>
            <div class="notification-item" [ngClass]="{'active': ID === 6}" (click)="SelectItx(6)"
                (keydown.enter)="SelectItx(6)" (keydown.space)="SelectItx(6)" tabindex="7">
                <i class="fas fa-bullhorn icon"></i>
                <span>Reportar incidencias</span>
            </div>
            <div class="total-notifications"></div>
        </div>
        }
        @if(bPermisoAdmin || bSuperAdmin){
        <div class="sidebar-section">
            <h3>Administrador:</h3>
            <!--     <div class="sidebar-link" [ngClass]="{'active': ID === 8}" (click)="SelectItx(8)">
                    <i class="fas fa-cog icon"></i>
                    <span>Servicio</span>
                </div> -->
            <div class="notification-item" [ngClass]="{'active': ID === 9}" (click)="SelectItx(9)"
                (keydown.enter)="SelectItx(9)" (keydown.space)="SelectItx(9)" tabindex="8">
                <i class="fas fa-cog icon"></i>
                <span>Días inhábiles</span>
            </div>
        </div>
        }
        <div class="sidebar-section">
            <h3>Ayuda:</h3>
            <div class="notification-item" [ngClass]="{'active': ID === 11}" (click)="SelectItx(11)"
                (keydown.enter)="SelectItx(11)" (keydown.space)="SelectItx(11)" tabindex="9">
                <i class="fas fa-question-circle icon"></i>
                <span>Manuales y Tutoriales</span>
            </div>
            <div class="total-notifications"></div>
        </div>
    </aside>

    <main class="content-area">
        <router-outlet></router-outlet>
    </main>
</div>